import React, {useEffect, useState} from 'react';
import Modal from "react-modal";
import {Link} from "react-scroll";
import DiseaseIdentify from "./DiseaseIdentify";
import PricePrediction from "./PricePrediction";
import FoodBanking from "./FoodBanking";
import DirectBuySell from "./DirectBuySell";

const customStyles = {
    content: {
        top: '20%',
        left: '10%',
        right: '10%',
        bottom: '20%',
    },
};

Modal.setAppElement('#root');
const FunctionsMore = (props) => {
    const { service } = props;
    const [modal1IsOpen, setModal1IsOpen ] = useState(false);
    const [modal2IsOpen, setModal2IsOpen ] = useState(false);
    const [modal3IsOpen, setModal3IsOpen ] = useState(false);
    const [modal4IsOpen, setModal4IsOpen ] = useState(false);

    useEffect(() => {
        if(modal1IsOpen || modal2IsOpen || modal3IsOpen || modal4IsOpen ){
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
    });

    // model1
    const handleOpenModal = () => {
        if (service === '01') {
            setModal1IsOpen(true)
        }
        if ( service === '02' ) {
            setModal2IsOpen(true)
        }
        if ( service === '03' ) {
            setModal3IsOpen(true)
        }
        if ( service === '04' ) {
            setModal4IsOpen(true)
        }

    }

    return (
        <div>
            <Link className="nav-link" activeClass="active" to="home" ><button className="btn learn_btn_two" onClick={handleOpenModal}>
                Learn More <i className="ti-arrow-right"/>
            </button></Link>
            <Modal
                isOpen={modal1IsOpen}
                onRequestClose={()=> setModal1IsOpen(false)}
                contentLabel="Identify Diseases"
                style={customStyles}
            >
                <h2>Identify Diseases</h2>
                <DiseaseIdentify />
                <button className="btn btn-danger"  onClick={()=> setModal1IsOpen(false)}>Close</button>
            </Modal>
            <Modal
                isOpen={modal2IsOpen}
                onRequestClose={()=> setModal2IsOpen(false)}
                contentLabel="Price Prediction"
                style={customStyles}
            >
                <h2>Price Prediction</h2>
                <PricePrediction />
                <button className="btn btn-danger"  onClick={()=> setModal2IsOpen(false)}>Close</button>
            </Modal>
            <Modal
                isOpen={modal3IsOpen}
                onRequestClose={()=> setModal3IsOpen(false)}
                contentLabel="Food Banking"
                style={customStyles}
            >
                <h2>Food Banking</h2>
                <FoodBanking />
                <button className="btn btn-danger"  onClick={()=> setModal3IsOpen(false)}>Close</button>
            </Modal>
            <Modal
                isOpen={modal4IsOpen}
                onRequestClose={()=> setModal4IsOpen(false)}
                contentLabel="Direct buy & Sell"
                style={customStyles}
            >
                <h2>Direct buy & Sell</h2>
                <DirectBuySell />
                <button className="btn btn-danger"  onClick={()=> setModal4IsOpen(false)}>Close</button>
            </Modal>
        </div>
    );
}

export default FunctionsMore;
